'use client';

import { useEffect, useState } from 'react';
import { divisionItems } from './DivisionsSectionCarousel.data';
import { DivisionsSectionItem } from './DivisionsSectionItem';
import { css, cx } from '@onbeam/business-styled-system/css';
import { flex } from '@onbeam/business-styled-system/patterns';
import { motion, Transition } from 'motion/react';
import {
  ANIMATION_DURATION,
  CAROUSEL_ITEM_OFFSET_REM,
  CAROUSEL_ITEMS,
  CAROUSEL_WIDTH_REM,
  CENTER_INDEX,
  INITIAL_CAROUSEL_OFFSET_REM,
  SLIDE_INTERVAL,
} from './DivisionsSectionCarousel.utils';

const totalItems = divisionItems.length;

export const DivisionsSectionCarousel = () => {
  const [activeIndex, setActiveIndex] = useState(CENTER_INDEX);
  const [isAnimating, setAnimating] = useState(true);
  const [isAtEnd, setAtEnd] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prev) => prev + 1);
    }, SLIDE_INTERVAL);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (activeIndex >= totalItems + CENTER_INDEX) {
      setAtEnd(true);

      const timeout = setTimeout(() => {
        setAtEnd(false);
        setAnimating(false);
        setActiveIndex(CENTER_INDEX);
      }, ANIMATION_DURATION);
      return () => clearTimeout(timeout);
    }

    setAnimating(true);
  }, [activeIndex]);

  const transition: Transition = {
    ease: 'easeInOut',
    duration: isAnimating ? ANIMATION_DURATION / 1000 : 0,
  };

  return (
    <div
      className={cx(
        css({
          pos: 'relative',
          overflow: 'hidden',
          w: 'full',
          h: '[20rem]',
          mt: '3',
          mb: '5',
          md: { mb: '3' },
        }),
      )}
    >
      <motion.div
        className={flex({
          pos: 'absolute',
          left: '[50%]',
          transform: 'translateX(-50%)',
          gap: '10',
        })}
        style={{
          width: `${CAROUSEL_WIDTH_REM}rem`,
        }}
        initial={false}
        animate={{
          x: `-${INITIAL_CAROUSEL_OFFSET_REM + (activeIndex - CENTER_INDEX) * CAROUSEL_ITEM_OFFSET_REM}rem`,
        }}
        transition={transition}
      >
        {CAROUSEL_ITEMS.map((item, index) => (
          <DivisionsSectionItem
            key={`${item.name}-${index}`}
            isActive={index === activeIndex}
            isVisible={
              index >= activeIndex - CENTER_INDEX &&
              index <= activeIndex + CENTER_INDEX
            }
            isAtEnd={isAtEnd}
            transition={transition}
            {...item}
          />
        ))}
      </motion.div>
    </div>
  );
};
